import { connect } from 'react-redux';
import Campaign from '../components/Campaign';
import { open } from 'store/modules/modal';

const mapDispatchToProps = dispatch => ({
  showCampaignInfo(campaign) {
    dispatch(
      open({
        modalType: 'campaignInfo',
        modalProps: {
          campaign,
        },
      })
    );
  },
  openKeyManagement(campaign) {
    dispatch(
      open({
        modalType: 'keyManagement',
        modalProps: {
          campaign,
        },
      })
    );
  },
});

export default connect(
  null,
  mapDispatchToProps
)(Campaign);
